module.exports = __webpack_public_path__ + "media/34.c0a62664.mp3";